import axios from "axios";
import { API_URL } from "../_config/config.const";
import { getBody, getBodyWithNestedObject } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getDefaultHeader, getHeader, getUploadHeader } from "../_helpers/header.helper";

const API_NAME = "payment";

export const paymentService = {
    post,
    getMerchantSessionKey,
    getAcsResponse,
    postIframe,
    verifyTransaction
};

function post(model: any, isExtraCheck: boolean) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBodyWithNestedObject(model) };
    return fetch(`${API_URL}/payment/submitPayment/?isExtraCheck=${isExtraCheck}`, requestOptions).then(handleResponse);
}

function verifyTransaction(userCartId: number) {
    const requestOptions = { method: 'Get', headers: getHeader() };
    return fetch(`${API_URL}/payment/verifyTransaction/?userCartId=${userCartId}`, requestOptions).then(handleResponse);
}



function postIframe(url: string, model: any) {
    // const requestOptions = { method: 'POST', body: getBody(model) };
    // return fetch(`${url}`, requestOptions).then(handleResponse);

    var bodyFormData = new FormData();
    bodyFormData.append('creq', 'creq');
    bodyFormData.append('threeDSSessionData', 'threeDSSessionData');

    const a = {
        headers: getDefaultHeader()
    }

    return axios.post(`${url}`, bodyFormData, a);

}

function getMerchantSessionKey(isExtraCheck: boolean) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetMerchantSessionKey/?isExtraCheck=${isExtraCheck}`, requestOptions).then(handleResponse);
}

function getAcsResponse() {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAcsResponse`, requestOptions).then(handleResponse);
}